<template>
  <div class="container-fluid pm-page">
    <div class="pm-page-header pb-3">
      <h5 class="mb-0 font-weight-bold">Project Management</h5>
      <p class="text-secondary text-sm mb-0">Sub-project tracking &amp; status</p>
    </div>

    <div class="row pb-2 pm-page-main">
      <div class="col-12 pm-page-col">
        <div class="card pm-page-card">
          <div class="card-header pb-0">
            <div class="tab-shell" id="projectTabs" role="tablist" aria-label="Project management tabs">
              <button
                class="tab-item"
                :class="{ active: activeTab === 'project' }"
                @click="activeTab = 'project'"
                type="button"
              >Project</button>
              <button
                class="tab-item"
                :class="{ active: activeTab === 'subproject' }"
                @click="activeTab = 'subproject'"
                type="button"
              >Sub Project</button>
              <button
                class="tab-item"
                :class="{ active: activeTab === 'history' }"
                @click="activeTab = 'history'"
                type="button"
              >History</button>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2 pm-page-tab-body">
            <projects-table v-if="activeTab === 'project'" />
            <sub-projects-table v-else-if="activeTab === 'subproject'" view-mode="active" />
            <sub-projects-table v-else-if="activeTab === 'history'" view-mode="history" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectsTable from "./components/ProjectsTable";
import SubProjectsTable from "./components/SubProjectsTable";
import "@/assets/css/pm-tab-scroll.css";

export default {
  name: "tables",
  components: { ProjectsTable, SubProjectsTable },
  data() {
    return { activeTab: "project" };
  },
  mounted() {
    document.documentElement.classList.add("pm-scroll-lock");
  },
  beforeUnmount() {
    document.documentElement.classList.remove("pm-scroll-lock");
  },
};
</script>

<style scoped>
.pm-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.pm-page-main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pm-page-col {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.pm-page-card {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pm-page-tab-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.card-header.pb-0 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.tab-shell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.3rem;
  border-radius: 12px;
  background: transparent;
}
.tab-item {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #696969;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  padding: 0.55rem 0.9rem;
  line-height: 1.2;
  border: none;
  border-radius: 12px;
  background: #f5f5f5;
  cursor: pointer;
  transition: all 0.2s ease;
}
.tab-item.active {
  color: #ffffff;
  background: #344767;
  box-shadow: 0 6px 14px rgba(52, 71, 103, 0.28);
}
</style>
